import React, { useState, useEffect } from 'react'
import {
    Header, Icon
} from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { ChooseTemplate } from '../components'
import { getClient } from './../utils/functions'

const TemplateCatalog = () => {
  const client = getClient()
  const [data, setData] = useState(null)

  useEffect(() => {
    const baseURL = client.demoAPI
    const urls = [
      `${baseURL}/templates`,
    ]
    Promise.all(urls.map(url =>
      fetch(url, {
        method: 'GET',
      })
        .then(response => response.json())
        .catch((error) => {
          console.log('Error', error)
        })
    ))
      .then(response => {
        const { results = '' } = response?.[0]
        const catalog = results
        let data = JSON.parse(JSON.stringify(catalog))
          ?.sort((a, b) => parseInt(a.order) < parseInt(b.order))
        setData(data)
      })
  }, [])

  return (
    <div id='template-cataolg-container'>
      <Header as='h2'>
        <Icon name='edit' />
        <Header.Content>
          Template Catalog
          <Header.Subheader>
            Choose a template or start an <Link to={'/template/email/1'}>email</Link> or <Link to={'/template/page/1'}>page</Link> from scratch.
          </Header.Subheader>
        </Header.Content>
      </Header>
      <ChooseTemplate data={data} />
    </div>
  )
}

export default TemplateCatalog
